/**
 * Nano Icons' web renderer ignores the font passed to `createNanoIconSet` and draws glyphs in the
 * unhashed family `icons`, so the app registers it with its other fonts (TRO-2483).
 */
export const iconFont = { icons: require("../../../assets/icons/nanoicons/icons.woff2") };
